import React from 'react';
import MortgageCalculator from './MortgageCalculator';

function App() {
  return (
    // Add relative positioning to contain everything
    <div className="relative min-h-screen bg-[#FAFAFA]">
      {/* Calculator Container */}
      <div className="flex justify-center items-center p-4">
        <MortgageCalculator />
      </div>
    </div>
  );
}

export default App;